import { Paths } from 'type-fest';

import {
  Typography,
  Paper,
  Switches,
  CardHeader,
  IconAvatar,
  EmailOutlinedIcon,
} from '@occc-app/design-system';

import { EmailRequiredFormValues } from './email-required-constraint.types';

export const EmailRequiredConstraint = () => {
  return (
    <Paper>
      <CardHeader
        title={<Typography variant='subtitle1'>Email Required</Typography>}
        subheader={
          <Typography variant='body2' color='textSecondary'>
            Members must provide an email to be eligible. For OCX customers, "require activation"
            must be enabled
          </Typography>
        }
        action={
          <Switches
            name={`emailRequiredConstraint.isEnabled` satisfies Paths<EmailRequiredFormValues>}
            data={{}}
          />
        }
        avatar={<IconAvatar Icon={EmailOutlinedIcon} />}
        sx={{ py: 2, px: 3 }}
      />
    </Paper>
  );
};
